import { render, staticRenderFns } from "./PatientEmergency.vue?vue&type=template&id=24b13a9b&scoped=true"
import script from "./PatientEmergency.vue?vue&type=script&lang=js"
export * from "./PatientEmergency.vue?vue&type=script&lang=js"
import style0 from "./PatientEmergency.vue?vue&type=style&index=0&id=24b13a9b&prod&scoped=true&lang=css"
import style1 from "./PatientEmergency.vue?vue&type=style&index=1&id=24b13a9b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b13a9b",
  null
  
)

export default component.exports